export default __webpack_public_path__ + "static/media/PromoLogo.95843efa.webp";